import api from "../index";

// Response interfaces
export interface AccountStatusResponse {
  success: boolean;
  status: "active" | "disabled";
  hasPendingAction: boolean;
  pendingActionType: "disable" | "delete" | null;
  error?: string;
}

export interface AccountActionResponse {
  success: boolean;
  message?: string;
  error?: string;
  retryAfter?: number;
}

export interface VerifyActionResponse {
  success: boolean;
  action?: "disable" | "delete" | "reactivate";
  message?: string;
  error?: string;
}

// Get account status
export const getAccountStatus = () => {
  return api.get<AccountStatusResponse>("/account/status");
};

// Request disable account
export const requestDisableAccount = () => {
  return api.post<AccountActionResponse>("/account/disable/request");
};

// Request delete account
export const requestDeleteAccount = () => {
  return api.post<AccountActionResponse>("/account/delete/request");
};

// Request reactivate account (no auth required - user is disabled)
export const requestReactivateAccount = (email: string) => {
  return api.post<AccountActionResponse>("/account/reactivate/request", { email });
};

// Verify and execute account action (called from email link)
// No auth required - token is the auth
export const verifyAccountAction = (token: string) => {
  return api.post<VerifyActionResponse>("/account/action/verify", { token });
};
